import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"

const useStyles = makeStyles({
	enableIcon: {
		color: colors.green[600]
	},
	disableIcon: {
		color: colors.gray[500]
	},
	warningIcon: {
		color: colors.yellow[500]
	},
	warning: {
		"& .MuiOutlinedInput-notchedOutline": {
			borderColor: colors.yellow[500]
		},
		"& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
			borderColor: colors.yellow[600]
		},
		"&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
			borderColor: colors.yellow[600]
		},
		"&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
			borderColor: colors.yellow[600]
		},
		"& .MuiSelect-icon": {
			color: colors.yellow[500]
		},
		"& .MuiSelect-selectMenu": {
			color: colors.yellow[500]
		},
		"& .MuiInputBase-input": {
			color: colors.yellow[500]
		},
		"& .MuiSvgIcon-root": {
			fill: colors.yellow[500]
		}
	},
	warningDialogText: {
		color: colors.gray[600],
		fontSize: "14px",
		fontWeight: 400,
		lineHeight: "24px"
	},
	selectInput: {
		height: "40px",
		margin: "3px 0px",
		textTransform: "none"
	},
	statusIconCell: {
		textAlign: "center",
		paddingTop: "12px"
	}
})

export default useStyles
